import { showToast } from '@bp/ui-components';
import { t } from 'i18next';
import type { CombinedError } from 'urql';

const autoCloseTime = 2000;

export function showErrorToast(error: CombinedError | string) {
  if (typeof error === 'string') {
    showToast(error ?? t('toast.error.common'), {
      autoClose: autoCloseTime,
      type: 'error',
    });
  } else {
    showToast(`Error - ${error.message}`, {
      type: 'error',
    });
  }
}
